import Vue from 'vue';

export const EventBus = new Vue();

/** Форма создания шлёт событие, когда вкладка связок может быть ещё не смонтирована */
export const MM_APPLY_ASSIGNMENT_FILTERS = 'mm-apply-assignment-filters';
